import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    error: null,
    testData: null
}

const TestReducer = createSlice({
    name: "TestData",
    initialState,
    reducers:{
        fetchRequest: (state) => {
            state.isLoading = true;
            state.error = null
        },
        fetchSuccess: (state, action) => {
            state.isLoading = true;
            state.testData = action.payload;
        },
        fetchFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        resetData: (state) => {
            state.isLoading = false;
            state.items = [];
            state.error = null
        }
    }
})

export const {
    fetchRequest,
    fetchFailure,
    fetchSuccess,
    resetData
} = TestReducer.actions;

export default TestReducer.reducer